// extracted by mini-css-extract-plugin
export default {"more_datails":"MoreVertical_more_datails__2kvtT","open_more":"MoreVertical_open_more__rvnkd","menu_root":"MoreVertical_menu_root__NPNDI","menu_item":"MoreVertical_menu_item__r4nt8"};